import React from 'react'

import { AgreeTerms } from 'core/application/adminSignUp/common/models'
import { perksConfirmSubscriptionFeesApi } from 'core/application/adminSignUp/perks/subscriptionFees'

import { BaseNavigationProps } from 'common/wizard/BaseNavigationProps'

import SubscriptionFees from '../../common/SubscriptionFees'

const PerksSubscriptionFees: React.FC<BaseNavigationProps<AgreeTerms>> = (props) => {
  return (
    <SubscriptionFees
      name={props.name}
      serviceAgreement={props.state.serviceAgreement}
      discountCode={props.state.discountCode}
      subscriptionPackageCode={props.state.subscriptionPackageCode}
      planCode={props.state.planCode}
      goNext={props.goNext}
      state={props.state}
      goBack={props.goBack}
      hasDirtyData={props.hasDirtyData}
      submitFormHandler={(values: any) => perksConfirmSubscriptionFeesApi(values)}
    />
  )
}

export default PerksSubscriptionFees
